import React from 'react';

// DEPENDENCIES
import clsx from 'clsx';
import isNil from 'lodash/isNil';

// GLOBAL COMPONENTS
import Sprite from 'core/tools/Sprite';

// STYLES
import styles from './noResults.module.scss';

export default function NoResults({ icon, children, className }) {
  return (
    <div className={clsx('py-5 text-center text-muted', className)}>
      <div>
        {icon ? (
          <Sprite use={icon.use || icon} className={clsx(styles.icon, icon?.size, 'mx-auto mb-1', icon.className)} />
        ) : null}
        {!isNil(children) ? children : <div>No Results Found</div>}
      </div>
    </div>
  );
}
